import { Streami18n } from 'stream-chat-react'

import { getLocale, trans } from './trans'

// Stream translations, with our own wording where Stream's doesn't fit
export const streamI18n = new Streami18n({
    language: getLocale(),
    translationsForLanguage: {
        // Empty conversation (message list); the conversation list has its own empty state
        'No chats here yet…': trans('pages.messages.noMessagesYet'),
    },
})
